import { render, staticRenderFns } from "./ticketNum.vue?vue&type=template&id=8585b87e&scoped=true&"
import script from "./ticketNum.vue?vue&type=script&lang=js&"
export * from "./ticketNum.vue?vue&type=script&lang=js&"
import style0 from "./ticketNum.vue?vue&type=style&index=0&id=8585b87e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8585b87e",
  null
  
)

export default component.exports